import { SearchOff } from '@mui/icons-material'
import { CircularProgress, Grid, Typography } from '@mui/material'
import React from 'react'

import './style.scss'

interface ContentLoaderProps {
  hasItems: boolean
  retrieved: boolean
  notFoundHeaderText?: string
  notFoundText?: string
  className?: string
  dark?: boolean
  children: React.ReactNode
  skeleton?: JSX.Element
}

class ContentLoader extends React.Component<ContentLoaderProps> {
  static defaultProps = { hasItems: true }

  render() {
    const { notFoundHeaderText, notFoundText, retrieved, hasItems, className, dark, children } =
      this.props

    if (retrieved) {
      if (hasItems) {
        return children
      } else {
        return (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            className={`not-found ${className} ${dark ? 'dark' : ''}`}
            sx={{ minHeight: '200px', textAlign: 'center', py: 4 }}
          >
            <Grid item>
              <div className="icon-container">
                <SearchOff sx={{ fontSize: 80, color: 'text.secondary', opacity: 0.5 }} />
              </div>
              {notFoundHeaderText && (
                <Typography
                  variant="h5"
                  sx={{
                    marginTop: 2,
                    marginBottom: 1,
                    fontWeight: 600,
                    color: 'text.primary'
                  }}
                >
                  {notFoundHeaderText}
                </Typography>
              )}
              <Typography
                variant="body1"
                className="title"
                sx={{
                  color: dark ? 'text.primary' : 'text.secondary',
                  fontSize: '16px'
                }}
              >
                {notFoundText || 'No items found.'}
              </Typography>
            </Grid>
          </Grid>
        )
      }
    }

    return this.props.skeleton ? (
      this.props.skeleton
    ) : (
      <Grid className="loading-container" justifyContent="center" alignItems="center" container>
        <CircularProgress size={35} />
      </Grid>
    )
  }
}

export default ContentLoader
